import { FC } from "react";
import { StaticInfo } from "../../parts/StaticInfo";
import PageSection from "../../parts/StaticPageSection";
import { Helmet } from "react-helmet";

export const CompanyPage: FC = () => {
  return <>
    <Helmet>
      <title>運営会社 - Drop AI</title>
      <meta name="description" content="Drop AIの運営会社情報を確認できます。" />

      <meta property="og:url" content="https://drop4i.com/company" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="運営会社 - Drop AI | 無料で使えるAI画像生成ツール" />
      <meta property="og:description" content="Drop AIの運営会社情報を確認できます。" />
    </Helmet>
    <PageSection title="会社概要">
      <StaticInfo title="運営会社" value="株式会社 GO TO MARKET" />
      <StaticInfo title="所在地" value="東京都渋谷区道玄坂1-2-3 渋谷フクラス17F" />
      <StaticInfo title="設立" value="2020年 2月" />
      <StaticInfo title="代表者" value="代表取締役 木村 暁生" />
      <StaticInfo title="事業内容" value="インターネットサービス事業、マーケティング事業" />
    </PageSection>
  </>;
}